var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "preview-container" }, [
        _c("div", { staticClass: "preview-header" }, [
          _c("div", { staticClass: "header-left" }, [
            _c("span", { staticClass: "business-title" }, [
              _vm._v(_vm._s(_vm.formConfig.name))
            ]),
            _vm.isRevision
              ? _c("span", { staticClass: "readonly-reminder" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "CargoMsg.Cargo_FormPreviewInRevisionViewIsReadOnly"
                      )
                    )
                  )
                ])
              : _vm._e(),
            !_vm.isRevision && _vm.readonly
              ? _c("span", { staticClass: "readonly-reminder" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("CargoMsg.Cargo_FormPreviewInListViewIsReadOnly")
                    )
                  )
                ])
              : _vm._e()
          ]),
          _c(
            "div",
            { staticClass: "header-right" },
            [
              _vm.isBatchMode
                ? _c(
                    "span",
                    {
                      staticClass: "batch-mode-indicator",
                      staticStyle: { "font-size": "14px", color: "#f57979" }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("CargoMsg.Cargo_BatchFill")) + " "
                      )
                    ]
                  )
                : [
                    !_vm.debug && _vm.jobFull
                      ? _c(
                          "span",
                          {
                            staticClass: "red",
                            staticStyle: { "font-size": "14px" },
                            attrs: { no: "SopState" }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.ColumnUtils.getJobState(_vm.jobFull)
                                ) +
                                " "
                            )
                          ]
                        )
                      : _vm._e(),
                    !_vm.debug && _vm.jobFull && _vm.jobFull.jobNo
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              color: "unset",
                              "margin-left": "10px"
                            }
                          },
                          [_vm._v(" " + _vm._s(_vm.jobFull.jobNo) + " ")]
                        )
                      : _vm._e()
                  ]
            ],
            2
          )
        ]),
        !_vm.isDataReady
          ? _c("div", { staticClass: "loading-container" }, [
              _c("span", { staticClass: "loading-text" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DataLoadingPleaseWait")))
              ])
            ])
          : _vm.isSe
          ? _c(
              "div",
              { staticClass: "preview-content" },
              [
                _vm.hasHblElements
                  ? _c(
                      "div",
                      { staticClass: "document-selector" },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: {
                              width: "300px",
                              "margin-right": "10px"
                            },
                            attrs: {
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_SelectHblDocument"
                              ),
                              size: "small",
                              "value-key": "value"
                            },
                            on: {
                              change: function($event) {
                                return _vm.eManage.updateFormData()
                              }
                            },
                            model: {
                              value: _vm.selectedHbl,
                              callback: function($$v) {
                                _vm.selectedHbl = $$v
                              },
                              expression: "selectedHbl"
                            }
                          },
                          _vm._l(_vm.availableHblDocuments, function(doc) {
                            return _c("el-option", {
                              key: doc.key,
                              attrs: { label: doc.label, value: doc.value }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.hasHawb2Elements
                  ? _c(
                      "div",
                      { staticClass: "document-selector" },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: {
                              width: "300px",
                              "margin-right": "10px"
                            },
                            attrs: {
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_SelectHawb2Document"
                              ),
                              size: "small",
                              "value-key": "value"
                            },
                            on: {
                              change: function($event) {
                                return _vm.eManage.updateFormData()
                              }
                            },
                            model: {
                              value: _vm.selectedHawb2,
                              callback: function($$v) {
                                _vm.selectedHawb2 = $$v
                              },
                              expression: "selectedHawb2"
                            }
                          },
                          _vm._l(_vm.availableHawb2Documents, function(doc) {
                            return _c("el-option", {
                              key: doc.key,
                              attrs: { label: doc.label, value: doc.value }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._l(_vm.pageParts, function(pagePart) {
                  return _c(
                    "div",
                    { key: pagePart.id, staticClass: "preview-section" },
                    [
                      _c("div", { staticClass: "section-header" }, [
                        _c("span", { staticClass: "section-title" }, [
                          _vm._v(_vm._s(_vm.getLocalizedName(pagePart)))
                        ])
                      ]),
                      _c("div", { staticClass: "section-content" }, [
                        pagePart.blockType ===
                        _vm.PAGE_PART_TYPE.BUSINESS_ELEMENTS.value
                          ? _c(
                              "div",
                              { staticClass: "element-grid" },
                              [
                                _vm._l(pagePart.elements, function(element) {
                                  return [
                                    _vm.isElementVisible(element) &&
                                    (_vm.eManageGet(element)
                                      ? !_vm.eManageGet(
                                          element,
                                          _vm.eManage.refreshId
                                        ).hide
                                      : true)
                                      ? _c(
                                          "div",
                                          {
                                            key: element.uuid,
                                            staticClass: "element-item",
                                            class: {
                                              "has-error":
                                                _vm.elementErrors[
                                                  element.elementName
                                                ],
                                              "full-width": _vm.showFullWidth(
                                                element
                                              ),
                                              cleared:
                                                _vm.clearStates[
                                                  element.elementName
                                                ]
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "element-label",
                                                class: {
                                                  required:
                                                    element.isRequire ||
                                                    element.isDefaultRequire
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getLocalizedName(
                                                      element
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm.eManageGet(element)
                                              ? _c(
                                                  _vm.eManageGet(element)
                                                    .component,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        key: _vm.getElementKey(
                                                          element
                                                        ),
                                                        ref:
                                                          element.elementName,
                                                        refInFor: true,
                                                        tag: "component",
                                                        class: {
                                                          "is-error":
                                                            _vm.elementErrors[
                                                              element
                                                                .elementName
                                                            ]
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            _vm.isElementDisabled(
                                                              element
                                                            ) ||
                                                            _vm.eManageGet(
                                                              element,
                                                              _vm.eManage
                                                                .refreshId
                                                            ).disabled ||
                                                            _vm.clearStates[
                                                              element
                                                                .elementName
                                                            ],
                                                          value: _vm.getFormFieldValueFormatter(
                                                            element.elementName,
                                                            element.pageType,
                                                            _vm.job
                                                          )
                                                        },
                                                        on: {
                                                          input: function(val) {
                                                            return _vm.handleElementInput(
                                                              element,
                                                              val,
                                                              _vm.eManageGet(
                                                                element,
                                                                _vm.eManage
                                                                  .refreshId
                                                              ).convertValue
                                                            )
                                                          },
                                                          change: function(
                                                            val
                                                          ) {
                                                            return _vm.handleElementChange(
                                                              element,
                                                              val,
                                                              _vm.eManageGet(
                                                                element,
                                                                _vm.eManage
                                                                  .refreshId
                                                              ).convertValue
                                                            )
                                                          },
                                                          childrenChange: function(
                                                            data
                                                          ) {
                                                            return _vm.processElementChange(
                                                              element,
                                                              "",
                                                              data
                                                            )
                                                          }
                                                        }
                                                      },
                                                      "component",
                                                      _vm.eManageGet(
                                                        element,
                                                        _vm.eManage.refreshId
                                                      ).props,
                                                      false
                                                    ),
                                                    _vm.eManageGet(
                                                      element,
                                                      _vm.eManage.refreshId
                                                    ).listeners || {}
                                                  )
                                                )
                                              : _vm.isDatePicker(element)
                                              ? _c(
                                                  "el-date-picker",
                                                  _vm._b(
                                                    {
                                                      key: element.elementName,
                                                      ref: element.elementName,
                                                      refInFor: true,
                                                      class: {
                                                        "is-error":
                                                          _vm.elementErrors[
                                                            element.elementName
                                                          ]
                                                      },
                                                      attrs: {
                                                        value: _vm.getFormFieldValue(
                                                          element.elementName,
                                                          element.pageType,
                                                          _vm.job
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "CargoMsg.Cargo_EnterValue"
                                                        ),
                                                        size: "small",
                                                        disabled:
                                                          _vm.isElementDisabled(
                                                            element
                                                          ) ||
                                                          _vm.clearStates[
                                                            element.elementName
                                                          ]
                                                      },
                                                      on: {
                                                        input: function(val) {
                                                          return _vm.handleElementInput(
                                                            element,
                                                            val
                                                          )
                                                        },
                                                        change: function(val) {
                                                          return _vm.handleElementChange(
                                                            element,
                                                            val
                                                          )
                                                        }
                                                      }
                                                    },
                                                    "el-date-picker",
                                                    _vm.getElementProps(
                                                      element,
                                                      _vm.job
                                                    ),
                                                    false
                                                  )
                                                )
                                              : _vm.isDatePickerShowWeek(
                                                  element
                                                )
                                              ? _c(
                                                  "date-picker-show-week",
                                                  _vm._b(
                                                    {
                                                      key: element.elementName,
                                                      ref: element.elementName,
                                                      refInFor: true,
                                                      class: {
                                                        "is-error":
                                                          _vm.elementErrors[
                                                            element.elementName
                                                          ]
                                                      },
                                                      attrs: {
                                                        value: _vm.getFormFieldValue(
                                                          element.elementName,
                                                          element.pageType,
                                                          _vm.job
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "CargoMsg.Cargo_EnterValue"
                                                        ),
                                                        size: "small",
                                                        disabled:
                                                          _vm.isElementDisabled(
                                                            element
                                                          ) ||
                                                          _vm.clearStates[
                                                            element.elementName
                                                          ]
                                                      },
                                                      on: {
                                                        input: function(val) {
                                                          return _vm.handleElementInput(
                                                            element,
                                                            val
                                                          )
                                                        },
                                                        change: function(val) {
                                                          return _vm.handleElementChange(
                                                            element,
                                                            val
                                                          )
                                                        }
                                                      }
                                                    },
                                                    "date-picker-show-week",
                                                    _vm.getElementProps(
                                                      element,
                                                      _vm.job
                                                    ),
                                                    false
                                                  )
                                                )
                                              : element.elementName === "seaEq"
                                              ? [
                                                  _vm.job.containerLoadType ===
                                                    "FCL" ||
                                                  _vm.job.containerLoadType ===
                                                    "BB" ||
                                                  _vm.job.containerLoadType ===
                                                    "BCF" ||
                                                  _vm.job.masterFlag
                                                    ? _c(
                                                        "booking-sea-eq-data-grid",
                                                        {
                                                          attrs: {
                                                            value:
                                                              _vm.job.seaEQ,
                                                            "container-load-type":
                                                              _vm.job
                                                                .containerLoadType,
                                                            "is-edit": !_vm.isElementDisabled(
                                                              element
                                                            ),
                                                            job: _vm.job
                                                          },
                                                          on: {
                                                            eqQuantityChange:
                                                              _vm.eqQuantityChangeHandler
                                                          }
                                                        }
                                                      )
                                                    : _vm.job
                                                        .containerLoadType ===
                                                      "BULK"
                                                    ? _c(
                                                        "booking-bulk-data-grid",
                                                        {
                                                          attrs: {
                                                            value:
                                                              _vm.job
                                                                .cargoBulkDetail,
                                                            context:
                                                              _vm.context,
                                                            "job-uuid":
                                                              _vm.job.uuid,
                                                            "is-edit": !_vm.isElementDisabled(
                                                              element
                                                            )
                                                          }
                                                        }
                                                      )
                                                    : _vm.job
                                                        .containerLoadType ===
                                                      "SPA"
                                                    ? _c(
                                                        "booking-special-data-grid",
                                                        {
                                                          attrs: {
                                                            value:
                                                              _vm.job.seaEQ,
                                                            "is-edit": !_vm.isElementDisabled(
                                                              element
                                                            ),
                                                            job: _vm.job
                                                          },
                                                          on: {
                                                            eqQuantityChange:
                                                              _vm.eqQuantityChangeHandler
                                                          }
                                                        }
                                                      )
                                                    : _c("div", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "CargoMsg.Cargo_None"
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ])
                                                ]
                                              : element.pageType ===
                                                  _vm.SEA_BOOKING_VIRTUAL_HBL &&
                                                element.elementName ===
                                                  "orderBusinessAssociation"
                                              ? [
                                                  _c(
                                                    "se-sub-bill-order-business-association",
                                                    {
                                                      attrs: {
                                                        job: _vm.job,
                                                        "cargo-doc-list":
                                                          _vm.job
                                                            .seaCargoDocs || [],
                                                        "type-virtual-hbl":
                                                          _vm.job
                                                            .typeVirtualHbl,
                                                        disabled:
                                                          _vm.isElementDisabled(
                                                            element
                                                          ) ||
                                                          _vm.clearStates[
                                                            element.elementName
                                                          ]
                                                      }
                                                    }
                                                  )
                                                ]
                                              : _c(
                                                  _vm.elementComponentMap[
                                                    element.elementName
                                                  ] || "el-input",
                                                  _vm._b(
                                                    {
                                                      key: element.elementName,
                                                      ref: element.elementName,
                                                      refInFor: true,
                                                      tag: "component",
                                                      class: {
                                                        "is-error":
                                                          _vm.elementErrors[
                                                            element.elementName
                                                          ]
                                                      },
                                                      attrs: {
                                                        value: _vm.getFormFieldValueFormatter(
                                                          element.elementName,
                                                          element.pageType,
                                                          _vm.job
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "CargoMsg.Cargo_EnterValue"
                                                        ),
                                                        size: "small",
                                                        disabled:
                                                          _vm.isElementDisabled(
                                                            element
                                                          ) ||
                                                          _vm.clearStates[
                                                            element.elementName
                                                          ]
                                                      },
                                                      on: {
                                                        input: function(val) {
                                                          return _vm.handleElementInput(
                                                            element,
                                                            val
                                                          )
                                                        },
                                                        change: function(val) {
                                                          return _vm.handleElementChange(
                                                            element,
                                                            val
                                                          )
                                                        },
                                                        childrenChange: function(
                                                          data
                                                        ) {
                                                          return _vm.processElementChange(
                                                            element,
                                                            "",
                                                            data
                                                          )
                                                        }
                                                      }
                                                    },
                                                    "component",
                                                    _vm.getElementProps(
                                                      element,
                                                      _vm.job
                                                    ),
                                                    false
                                                  ),
                                                  [
                                                    _vm.isSelectType(
                                                      _vm.elementComponentMap[
                                                        element.elementName
                                                      ]
                                                    )
                                                      ? _vm._l(
                                                          _vm.getElementSelectOptions(
                                                            element
                                                          ),
                                                          function(
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: _vm.getOptionProp(
                                                                  item,
                                                                  index,
                                                                  element,
                                                                  "key"
                                                                ),
                                                                attrs: {
                                                                  label: _vm.getOptionProp(
                                                                    item,
                                                                    index,
                                                                    element,
                                                                    "label"
                                                                  ),
                                                                  value: _vm.getOptionProp(
                                                                    item,
                                                                    index,
                                                                    element,
                                                                    "value"
                                                                  )
                                                                }
                                                              }
                                                            )
                                                          }
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  2
                                                ),
                                            _vm.elementErrors[
                                              element.elementName
                                            ]
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "error-message"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.elementErrors[
                                                            element.elementName
                                                          ]
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.isBatchMode &&
                                            !_vm.isElementDisabled(element)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "clear-checkbox-container"
                                                  },
                                                  [
                                                    _c(
                                                      "el-checkbox",
                                                      {
                                                        staticClass:
                                                          "clear-checkbox",
                                                        attrs: {
                                                          disabled:
                                                            _vm.isElementDisabled(
                                                              element
                                                            ) ||
                                                            (_vm.eManageGet(
                                                              element,
                                                              _vm.eManage
                                                                .refreshId
                                                            ) &&
                                                              _vm.eManageGet(
                                                                element,
                                                                _vm.eManage
                                                                  .refreshId
                                                              ).disabled)
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.handleClearChange(
                                                              element.elementName,
                                                              $event
                                                            )
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.clearStates[
                                                              element
                                                                .elementName
                                                            ],
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.clearStates,
                                                              element.elementName,
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "clearStates[element.elementName]"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "CargoMsg.Cargo_ClearData"
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ]
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm.isCsnInfoPagePartType(pagePart.blockType)
                          ? _c("div", [
                              pagePart.blockType ===
                              _vm.PAGE_PART_TYPE.CSN_INFO_SE_BASIC.value
                                ? _c(
                                    "div",
                                    { staticClass: "csn-basic-layout" },
                                    [
                                      _vm.checkCsnFlag(pagePart, "needShipper")
                                        ? _c(
                                            "div",
                                            { staticClass: "csn-component" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "csn-component-header"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "csn-component-label"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_Shipper"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm.isBatchMode &&
                                                  !_vm.checkCsnFlag(
                                                    pagePart,
                                                    "isReadonly"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "clear-checkbox-container"
                                                        },
                                                        [
                                                          _c(
                                                            "el-checkbox",
                                                            {
                                                              staticClass:
                                                                "clear-checkbox",
                                                              attrs: {
                                                                disabled: _vm.checkCsnFlag(
                                                                  pagePart,
                                                                  "isReadonly"
                                                                )
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.handleCsnClearChange(
                                                                    "shipper",
                                                                    $event
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .clearStates[
                                                                    "shipper"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.clearStates,
                                                                    "shipper",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "clearStates['shipper']"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "CargoMsg.Cargo_ClearData"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _c("se-basic-shipper", {
                                                attrs: {
                                                  job: _vm.job,
                                                  disabled:
                                                    _vm.checkCsnFlag(
                                                      pagePart,
                                                      "isReadonly"
                                                    ) ||
                                                    _vm.clearStates["shipper"]
                                                },
                                                on: {
                                                  childrenChange: function(
                                                    $event
                                                  ) {
                                                    return _vm.handleCsnComponentChange(
                                                      pagePart,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.checkCsnFlag(
                                        pagePart,
                                        "needConsignee"
                                      )
                                        ? _c(
                                            "div",
                                            { staticClass: "csn-component" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "csn-component-header"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "csn-component-label"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_Consignee"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm.isBatchMode &&
                                                  !_vm.checkCsnFlag(
                                                    pagePart,
                                                    "isReadonly"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "clear-checkbox-container"
                                                        },
                                                        [
                                                          _c(
                                                            "el-checkbox",
                                                            {
                                                              staticClass:
                                                                "clear-checkbox",
                                                              attrs: {
                                                                disabled: _vm.checkCsnFlag(
                                                                  pagePart,
                                                                  "isReadonly"
                                                                )
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.handleCsnClearChange(
                                                                    "consignee",
                                                                    $event
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .clearStates[
                                                                    "consignee"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.clearStates,
                                                                    "consignee",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "clearStates['consignee']"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "CargoMsg.Cargo_ClearData"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _c("se-basic-consignee", {
                                                attrs: {
                                                  job: _vm.job,
                                                  disabled:
                                                    _vm.checkCsnFlag(
                                                      pagePart,
                                                      "isReadonly"
                                                    ) ||
                                                    _vm.clearStates["consignee"]
                                                },
                                                on: {
                                                  childrenChange: function(
                                                    $event
                                                  ) {
                                                    return _vm.handleCsnComponentChange(
                                                      pagePart,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.checkCsnFlag(pagePart, "needNotify")
                                        ? _c(
                                            "div",
                                            { staticClass: "csn-component" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "csn-component-header"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "csn-component-label"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_Notify"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm.isBatchMode &&
                                                  !_vm.checkCsnFlag(
                                                    pagePart,
                                                    "isReadonly"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "clear-checkbox-container"
                                                        },
                                                        [
                                                          _c(
                                                            "el-checkbox",
                                                            {
                                                              staticClass:
                                                                "clear-checkbox",
                                                              attrs: {
                                                                disabled: _vm.checkCsnFlag(
                                                                  pagePart,
                                                                  "isReadonly"
                                                                )
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.handleCsnClearChange(
                                                                    "notify",
                                                                    $event
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .clearStates[
                                                                    "notify"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.clearStates,
                                                                    "notify",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "clearStates['notify']"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "CargoMsg.Cargo_ClearData"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _c("se-basic-notify", {
                                                attrs: {
                                                  job: _vm.job,
                                                  disabled:
                                                    _vm.checkCsnFlag(
                                                      pagePart,
                                                      "isReadonly"
                                                    ) ||
                                                    _vm.clearStates["notify"]
                                                },
                                                on: {
                                                  childrenChange: function(
                                                    $event
                                                  ) {
                                                    return _vm.handleCsnComponentChange(
                                                      pagePart,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.checkCsnFlag(
                                        pagePart,
                                        "needAlsoNotify"
                                      )
                                        ? _c(
                                            "div",
                                            { staticClass: "csn-component" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "csn-component-header"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "csn-component-label"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "SeaExport.SecondNotifyParty"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm.isBatchMode &&
                                                  !_vm.checkCsnFlag(
                                                    pagePart,
                                                    "isReadonly"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "clear-checkbox-container"
                                                        },
                                                        [
                                                          _c(
                                                            "el-checkbox",
                                                            {
                                                              staticClass:
                                                                "clear-checkbox",
                                                              attrs: {
                                                                disabled: _vm.checkCsnFlag(
                                                                  pagePart,
                                                                  "isReadonly"
                                                                )
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.handleCsnClearChange(
                                                                    "alsoNotify",
                                                                    $event
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .clearStates[
                                                                    "alsoNotify"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.clearStates,
                                                                    "alsoNotify",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "clearStates['alsoNotify']"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "CargoMsg.Cargo_ClearData"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _c("cargo-rich-textarea", {
                                                staticStyle: {
                                                  width: "310px",
                                                  height: "230px"
                                                },
                                                attrs: {
                                                  no: "alsoNotify",
                                                  disabled:
                                                    _vm.checkCsnFlag(
                                                      pagePart,
                                                      "isReadonly"
                                                    ) ||
                                                    _vm.clearStates[
                                                      "alsoNotify"
                                                    ],
                                                  "text-chars": 0,
                                                  "wrap-symbol": "r"
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.handleAlsoNotifyChange(
                                                      pagePart,
                                                      $event
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: _vm.job.alsoNotify,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.job,
                                                      "alsoNotify",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "job.alsoNotify"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              pagePart.blockType ===
                                _vm.PAGE_PART_TYPE.CSN_INFO_SE_MBL.value &&
                              _vm.seaCargoDocMbl
                                ? _c(
                                    "div",
                                    { staticClass: "csn-basic-layout" },
                                    [
                                      _vm.checkCsnFlag(pagePart, "needShipper")
                                        ? _c(
                                            "div",
                                            { staticClass: "csn-component" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "csn-component-header"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "csn-component-label"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_Shipper"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm.isBatchMode &&
                                                  !_vm.checkCsnFlag(
                                                    pagePart,
                                                    "isReadonly"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "clear-checkbox-container"
                                                        },
                                                        [
                                                          _c(
                                                            "el-checkbox",
                                                            {
                                                              staticClass:
                                                                "clear-checkbox",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.isEmptyObj(
                                                                    _vm.seaCargoDocMbl
                                                                  ) ||
                                                                  _vm.checkCsnFlag(
                                                                    pagePart,
                                                                    "isReadonly"
                                                                  )
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.handleCsnClearChange(
                                                                    "mblShipper",
                                                                    $event
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .clearStates[
                                                                    "mblShipper"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.clearStates,
                                                                    "mblShipper",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "clearStates['mblShipper']"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "CargoMsg.Cargo_ClearData"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _c("se-cargo-doc-shipper", {
                                                attrs: {
                                                  "cargo-doc":
                                                    _vm.seaCargoDocMbl,
                                                  disabled:
                                                    _vm.isEmptyObj(
                                                      _vm.seaCargoDocMbl
                                                    ) ||
                                                    _vm.checkCsnFlag(
                                                      pagePart,
                                                      "isReadonly"
                                                    ) ||
                                                    _vm.clearStates[
                                                      "mblShipper"
                                                    ]
                                                },
                                                on: {
                                                  childrenChange: function(
                                                    $event
                                                  ) {
                                                    return _vm.handleCsnComponentChange(
                                                      pagePart,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.checkCsnFlag(
                                        pagePart,
                                        "needConsignee"
                                      )
                                        ? _c(
                                            "div",
                                            { staticClass: "csn-component" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "csn-component-header"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "csn-component-label"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_Consignee"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm.isBatchMode &&
                                                  !_vm.checkCsnFlag(
                                                    pagePart,
                                                    "isReadonly"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "clear-checkbox-container"
                                                        },
                                                        [
                                                          _c(
                                                            "el-checkbox",
                                                            {
                                                              staticClass:
                                                                "clear-checkbox",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.isEmptyObj(
                                                                    _vm.seaCargoDocMbl
                                                                  ) ||
                                                                  _vm.checkCsnFlag(
                                                                    pagePart,
                                                                    "isReadonly"
                                                                  )
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.handleCsnClearChange(
                                                                    "mblConsignee",
                                                                    $event
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .clearStates[
                                                                    "mblConsignee"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.clearStates,
                                                                    "mblConsignee",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "clearStates['mblConsignee']"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "CargoMsg.Cargo_ClearData"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _c("se-cargo-doc-consignee", {
                                                attrs: {
                                                  "cargo-doc":
                                                    _vm.seaCargoDocMbl,
                                                  disabled:
                                                    _vm.isEmptyObj(
                                                      _vm.seaCargoDocMbl
                                                    ) ||
                                                    _vm.checkCsnFlag(
                                                      pagePart,
                                                      "isReadonly"
                                                    ) ||
                                                    _vm.clearStates[
                                                      "mblConsignee"
                                                    ]
                                                },
                                                on: {
                                                  childrenChange: function(
                                                    $event
                                                  ) {
                                                    return _vm.handleCsnComponentChange(
                                                      pagePart,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.checkCsnFlag(pagePart, "needNotify")
                                        ? _c(
                                            "div",
                                            { staticClass: "csn-component" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "csn-component-header"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "csn-component-label"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_Notify"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm.isBatchMode &&
                                                  !_vm.checkCsnFlag(
                                                    pagePart,
                                                    "isReadonly"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "clear-checkbox-container"
                                                        },
                                                        [
                                                          _c(
                                                            "el-checkbox",
                                                            {
                                                              staticClass:
                                                                "clear-checkbox",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.isEmptyObj(
                                                                    _vm.seaCargoDocMbl
                                                                  ) ||
                                                                  _vm.checkCsnFlag(
                                                                    pagePart,
                                                                    "isReadonly"
                                                                  )
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.handleCsnClearChange(
                                                                    "mblNotify",
                                                                    $event
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .clearStates[
                                                                    "mblNotify"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.clearStates,
                                                                    "mblNotify",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "clearStates['mblNotify']"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "CargoMsg.Cargo_ClearData"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _c("se-mbl-notify", {
                                                attrs: {
                                                  "cargo-doc":
                                                    _vm.seaCargoDocMbl,
                                                  disabled:
                                                    _vm.isEmptyObj(
                                                      _vm.seaCargoDocMbl
                                                    ) ||
                                                    _vm.checkCsnFlag(
                                                      pagePart,
                                                      "isReadonly"
                                                    ) ||
                                                    _vm.clearStates["mblNotify"]
                                                },
                                                on: {
                                                  childrenChange: function(
                                                    $event
                                                  ) {
                                                    return _vm.handleCsnComponentChange(
                                                      pagePart,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              pagePart.blockType ===
                                _vm.PAGE_PART_TYPE.CSN_INFO_SE_HBL.value &&
                              _vm.seaCargoDocHbl
                                ? _c(
                                    "div",
                                    { staticClass: "csn-basic-layout" },
                                    [
                                      _vm.checkCsnFlag(pagePart, "needShipper")
                                        ? _c(
                                            "div",
                                            { staticClass: "csn-component" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "csn-component-header"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "csn-component-label"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_Shipper"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm.isBatchMode &&
                                                  !_vm.checkCsnFlag(
                                                    pagePart,
                                                    "isReadonly"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "clear-checkbox-container"
                                                        },
                                                        [
                                                          _c(
                                                            "el-checkbox",
                                                            {
                                                              staticClass:
                                                                "clear-checkbox",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.isEmptyObj(
                                                                    _vm.seaCargoDocHbl
                                                                  ) ||
                                                                  _vm.checkCsnFlag(
                                                                    pagePart,
                                                                    "isReadonly"
                                                                  )
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.handleCsnClearChange(
                                                                    "hblShipper",
                                                                    $event
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .clearStates[
                                                                    "hblShipper"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.clearStates,
                                                                    "hblShipper",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "clearStates['hblShipper']"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "CargoMsg.Cargo_ClearData"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _c("se-cargo-doc-shipper", {
                                                attrs: {
                                                  "cargo-doc":
                                                    _vm.seaCargoDocHbl,
                                                  disabled:
                                                    _vm.isEmptyObj(
                                                      _vm.seaCargoDocHbl
                                                    ) ||
                                                    _vm.checkCsnFlag(
                                                      pagePart,
                                                      "isReadonly"
                                                    ) ||
                                                    _vm.clearStates[
                                                      "hblShipper"
                                                    ]
                                                },
                                                on: {
                                                  childrenChange: function(
                                                    $event
                                                  ) {
                                                    return _vm.handleCsnComponentChange(
                                                      pagePart,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.checkCsnFlag(
                                        pagePart,
                                        "needConsignee"
                                      )
                                        ? _c(
                                            "div",
                                            { staticClass: "csn-component" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "csn-component-header"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "csn-component-label"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_Consignee"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm.isBatchMode &&
                                                  !_vm.checkCsnFlag(
                                                    pagePart,
                                                    "isReadonly"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "clear-checkbox-container"
                                                        },
                                                        [
                                                          _c(
                                                            "el-checkbox",
                                                            {
                                                              staticClass:
                                                                "clear-checkbox",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.isEmptyObj(
                                                                    _vm.seaCargoDocHbl
                                                                  ) ||
                                                                  _vm.checkCsnFlag(
                                                                    pagePart,
                                                                    "isReadonly"
                                                                  )
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.handleCsnClearChange(
                                                                    "hblConsignee",
                                                                    $event
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .clearStates[
                                                                    "hblConsignee"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.clearStates,
                                                                    "hblConsignee",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "clearStates['hblConsignee']"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "CargoMsg.Cargo_ClearData"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _c("se-cargo-doc-consignee", {
                                                attrs: {
                                                  "cargo-doc":
                                                    _vm.seaCargoDocHbl,
                                                  disabled:
                                                    _vm.isEmptyObj(
                                                      _vm.seaCargoDocHbl
                                                    ) ||
                                                    _vm.checkCsnFlag(
                                                      pagePart,
                                                      "isReadonly"
                                                    ) ||
                                                    _vm.clearStates[
                                                      "hblConsignee"
                                                    ]
                                                },
                                                on: {
                                                  childrenChange: function(
                                                    $event
                                                  ) {
                                                    return _vm.handleCsnComponentChange(
                                                      pagePart,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.checkCsnFlag(pagePart, "needNotify")
                                        ? _c(
                                            "div",
                                            { staticClass: "csn-component" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "csn-component-header"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "csn-component-label"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_Notify"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm.isBatchMode &&
                                                  !_vm.checkCsnFlag(
                                                    pagePart,
                                                    "isReadonly"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "clear-checkbox-container"
                                                        },
                                                        [
                                                          _c(
                                                            "el-checkbox",
                                                            {
                                                              staticClass:
                                                                "clear-checkbox",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.isEmptyObj(
                                                                    _vm.seaCargoDocHbl
                                                                  ) ||
                                                                  _vm.checkCsnFlag(
                                                                    pagePart,
                                                                    "isReadonly"
                                                                  )
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.handleCsnClearChange(
                                                                    "hblNotify",
                                                                    $event
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .clearStates[
                                                                    "hblNotify"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.clearStates,
                                                                    "hblNotify",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "clearStates['hblNotify']"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "CargoMsg.Cargo_ClearData"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _c("se-hbl-notify", {
                                                attrs: {
                                                  "cargo-doc":
                                                    _vm.seaCargoDocHbl,
                                                  disabled:
                                                    _vm.isEmptyObj(
                                                      _vm.seaCargoDocHbl
                                                    ) ||
                                                    _vm.checkCsnFlag(
                                                      pagePart,
                                                      "isReadonly"
                                                    ) ||
                                                    _vm.clearStates["hblNotify"]
                                                },
                                                on: {
                                                  childrenChange: function(
                                                    $event
                                                  ) {
                                                    return _vm.handleCsnComponentChange(
                                                      pagePart,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.checkCsnFlag(
                                        pagePart,
                                        "needAgentParty"
                                      )
                                        ? _c(
                                            "div",
                                            { staticClass: "csn-component" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "csn-component-label"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_AgentParty"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("se-hbl-agent-party", {
                                                attrs: {
                                                  job: _vm.job,
                                                  "cargo-doc":
                                                    _vm.seaCargoDocHbl,
                                                  disabled:
                                                    _vm.isEmptyObj(
                                                      _vm.seaCargoDocHbl
                                                    ) ||
                                                    _vm.checkCsnFlag(
                                                      pagePart,
                                                      "isReadonly"
                                                    )
                                                },
                                                on: {
                                                  childrenChange: function(
                                                    $event
                                                  ) {
                                                    return _vm.handleCsnComponentChange(
                                                      pagePart,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.checkCsnFlag(
                                        pagePart,
                                        "needAlsoNotify"
                                      )
                                        ? _c(
                                            "div",
                                            { staticClass: "csn-component" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "csn-component-header"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "csn-component-label"
                                                    },
                                                    [_vm._v("ALSO NOTIFY")]
                                                  ),
                                                  _vm.isBatchMode &&
                                                  !_vm.checkCsnFlag(
                                                    pagePart,
                                                    "isReadonly"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "clear-checkbox-container"
                                                        },
                                                        [
                                                          _c(
                                                            "el-checkbox",
                                                            {
                                                              staticClass:
                                                                "clear-checkbox",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.isEmptyObj(
                                                                    _vm.seaCargoDocHbl
                                                                  ) ||
                                                                  _vm.checkCsnFlag(
                                                                    pagePart,
                                                                    "isReadonly"
                                                                  )
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.handleCsnClearChange(
                                                                    "hblAlsoNotify",
                                                                    $event
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .clearStates[
                                                                    "hblAlsoNotify"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.clearStates,
                                                                    "hblAlsoNotify",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "clearStates['hblAlsoNotify']"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "CargoMsg.Cargo_ClearData"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _c("cargo-rich-textarea", {
                                                staticStyle: {
                                                  width: "310px",
                                                  height: "230px"
                                                },
                                                attrs: {
                                                  no: "alsoNotify",
                                                  disabled:
                                                    _vm.isEmptyObj(
                                                      _vm.seaCargoDocHbl
                                                    ) ||
                                                    _vm.checkCsnFlag(
                                                      pagePart,
                                                      "isReadonly"
                                                    ) ||
                                                    _vm.clearStates[
                                                      "hblAlsoNotify"
                                                    ],
                                                  "text-chars": 0,
                                                  "wrap-symbol": "r"
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.handleAlsoNotifyChange(
                                                      pagePart,
                                                      $event
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.seaCargoDocHbl
                                                      .alsoNotify,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.seaCargoDocHbl,
                                                      "alsoNotify",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "seaCargoDocHbl.alsoNotify"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              pagePart.blockType ===
                                _vm.PAGE_PART_TYPE.CSN_INFO_SE_HBL2.value &&
                              _vm.seaCargoDocHawb2
                                ? _c(
                                    "div",
                                    { staticClass: "csn-basic-layout" },
                                    [
                                      _vm.checkCsnFlag(pagePart, "needShipper")
                                        ? _c(
                                            "div",
                                            { staticClass: "csn-component" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "csn-component-label"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_Shipper"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("se-cargo-doc-shipper", {
                                                attrs: {
                                                  "cargo-doc":
                                                    _vm.seaCargoDocHawb2,
                                                  disabled:
                                                    _vm.isEmptyObj(
                                                      _vm.seaCargoDocHawb2
                                                    ) ||
                                                    _vm.checkCsnFlag(
                                                      pagePart,
                                                      "isReadonly"
                                                    )
                                                },
                                                on: {
                                                  childrenChange: function(
                                                    $event
                                                  ) {
                                                    return _vm.handleCsnComponentChange(
                                                      pagePart,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.checkCsnFlag(
                                        pagePart,
                                        "needConsignee"
                                      )
                                        ? _c(
                                            "div",
                                            { staticClass: "csn-component" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "csn-component-label"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_Consignee"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("se-cargo-doc-consignee", {
                                                attrs: {
                                                  "cargo-doc":
                                                    _vm.seaCargoDocHawb2,
                                                  disabled:
                                                    _vm.isEmptyObj(
                                                      _vm.seaCargoDocHawb2
                                                    ) ||
                                                    _vm.checkCsnFlag(
                                                      pagePart,
                                                      "isReadonly"
                                                    )
                                                },
                                                on: {
                                                  childrenChange: function(
                                                    $event
                                                  ) {
                                                    return _vm.handleCsnComponentChange(
                                                      pagePart,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.checkCsnFlag(pagePart, "needNotify")
                                        ? _c(
                                            "div",
                                            { staticClass: "csn-component" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "csn-component-label"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_Notify"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("se-hbl2-notify", {
                                                attrs: {
                                                  "cargo-doc":
                                                    _vm.seaCargoDocHawb2,
                                                  disabled:
                                                    _vm.isEmptyObj(
                                                      _vm.seaCargoDocHawb2
                                                    ) ||
                                                    _vm.checkCsnFlag(
                                                      pagePart,
                                                      "isReadonly"
                                                    )
                                                },
                                                on: {
                                                  childrenChange: function(
                                                    $event
                                                  ) {
                                                    return _vm.handleCsnComponentChange(
                                                      pagePart,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.checkCsnFlag(
                                        pagePart,
                                        "needAgentParty"
                                      )
                                        ? _c(
                                            "div",
                                            { staticClass: "csn-component" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "csn-component-label"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_AgentParty"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c("se-hbl2-agent-party", {
                                                attrs: {
                                                  job: _vm.job,
                                                  "cargo-doc":
                                                    _vm.seaCargoDocHawb2,
                                                  disabled:
                                                    _vm.isEmptyObj(
                                                      _vm.seaCargoDocHawb2
                                                    ) ||
                                                    _vm.checkCsnFlag(
                                                      pagePart,
                                                      "isReadonly"
                                                    )
                                                },
                                                on: {
                                                  childrenChange: function(
                                                    $event
                                                  ) {
                                                    return _vm.handleCsnComponentChange(
                                                      pagePart,
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.checkCsnFlag(
                                        pagePart,
                                        "needAlsoNotify"
                                      )
                                        ? _c(
                                            "div",
                                            { staticClass: "csn-component" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "csn-component-label"
                                                },
                                                [_vm._v("ALSO NOTIFY")]
                                              ),
                                              _c("cargo-rich-textarea", {
                                                staticStyle: {
                                                  width: "310px",
                                                  height: "230px"
                                                },
                                                attrs: {
                                                  no: "alsoNotify",
                                                  disabled:
                                                    _vm.isEmptyObj(
                                                      _vm.seaCargoDocHawb2
                                                    ) ||
                                                    _vm.checkCsnFlag(
                                                      pagePart,
                                                      "isReadonly"
                                                    ),
                                                  "text-chars": 0,
                                                  "wrap-symbol": "r"
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.handleAlsoNotifyChange(
                                                      pagePart,
                                                      $event
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.seaCargoDocHawb2
                                                      .alsoNotify,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.seaCargoDocHawb2,
                                                      "alsoNotify",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "seaCargoDocHawb2.alsoNotify"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        pagePart.blockType ===
                        _vm.PAGE_PART_TYPE.UPLOAD_FILE.value
                          ? _c(
                              "div",
                              { staticClass: "file-history-container" },
                              [
                                _c("tab-file-history", {
                                  ref: "tabFileHistory",
                                  refInFor: true,
                                  attrs: {
                                    context: _vm.context,
                                    "btn-info": _vm.btnInfo,
                                    "is-cross-tenant-se-to-si": false,
                                    "cooperate-edit": true,
                                    "preview-file-method":
                                      _vm.previewFileMethod,
                                    "can-operate-job": _vm.canOperateJob,
                                    "view-source": _vm.viewSource
                                  },
                                  on: {
                                    writebackJob: _vm.handleWritebackJob,
                                    mounted: function($event) {
                                      return _vm.handleComponentMounted(
                                        "tabFileHistory"
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        pagePart.blockType ===
                        _vm.PAGE_PART_TYPE.ACCOUNTS_RECEIVABLE.value
                          ? _c(
                              "div",
                              { staticClass: "charges-receivable-container" },
                              [
                                _c("tab-charges-no-resize", {
                                  ref: "tabChargesReceivable",
                                  refInFor: true,
                                  attrs: {
                                    context: _vm.context,
                                    action: _vm.action,
                                    "is-cross-tenant-se-to-si": false,
                                    location: _vm.location,
                                    "view-source": _vm.viewSource,
                                    "need-receivable": true,
                                    "need-payable": false
                                  },
                                  on: {
                                    ChargeLockStatusChange:
                                      _vm.chargeLockStatusChange,
                                    mounted: function($event) {
                                      return _vm.handleComponentMounted(
                                        "tabChargesReceivable"
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        pagePart.blockType ===
                        _vm.PAGE_PART_TYPE.ACCOUNTS_PAYABLE.value
                          ? _c(
                              "div",
                              { staticClass: "charges-payable-container" },
                              [
                                _c("tab-charges-no-resize", {
                                  ref: "tabChargesPayable",
                                  refInFor: true,
                                  attrs: {
                                    context: _vm.context,
                                    action: _vm.action,
                                    "is-cross-tenant-se-to-si": false,
                                    location: _vm.location,
                                    "view-source": _vm.viewSource,
                                    "need-receivable": false,
                                    "need-payable": true
                                  },
                                  on: {
                                    ChargeLockStatusChange:
                                      _vm.chargeLockStatusChange,
                                    mounted: function($event) {
                                      return _vm.handleComponentMounted(
                                        "tabChargesPayable"
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        pagePart.blockType ===
                        _vm.PAGE_PART_TYPE.CUSTOMS_INFO.value
                          ? _c(
                              "div",
                              { staticClass: "customs-info-container" },
                              [
                                _vm.$store.state.uiCustom.enable
                                  ? _c("tab-customs-info-UICustom", {
                                      ref: "tabCustomsInfo",
                                      refInFor: true,
                                      attrs: {
                                        "slave-customs-declaration-enable":
                                          _vm.slaveCustomsDeclarationEnable,
                                        context: _vm.context,
                                        action: _vm.inverseAction,
                                        "cooperate-edit": true
                                      },
                                      on: {
                                        mounted: function($event) {
                                          return _vm.handleComponentMounted(
                                            "tabCustomsInfo"
                                          )
                                        }
                                      }
                                    })
                                  : _c("tab-customs-info", {
                                      ref: "tabCustomsInfo",
                                      refInFor: true,
                                      attrs: {
                                        "slave-customs-declaration-enable":
                                          _vm.slaveCustomsDeclarationEnable,
                                        context: _vm.context,
                                        action: _vm.inverseAction,
                                        "cooperate-edit": true
                                      },
                                      on: {
                                        mounted: function($event) {
                                          return _vm.handleComponentMounted(
                                            "tabCustomsInfo"
                                          )
                                        }
                                      }
                                    })
                              ],
                              1
                            )
                          : _vm._e(),
                        pagePart.blockType ===
                        _vm.PAGE_PART_TYPE.OPERATION_AREA.value
                          ? _c(
                              "div",
                              { staticClass: "operation-area" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      width: "260px",
                                      "margin-right": "10px"
                                    },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "CargoMsg.Cargo_SelectBlDocument"
                                      ),
                                      size: "small",
                                      "value-key": "value",
                                      clearable: true
                                    },
                                    model: {
                                      value: _vm.selectedPrintDocument,
                                      callback: function($$v) {
                                        _vm.selectedPrintDocument = $$v
                                      },
                                      expression: "selectedPrintDocument"
                                    }
                                  },
                                  _vm._l(_vm.printableHblDocuments, function(
                                    doc
                                  ) {
                                    return _c("el-option", {
                                      key: doc.key,
                                      attrs: {
                                        label: doc.label,
                                        value: doc.value
                                      }
                                    })
                                  }),
                                  1
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      disabled: !_vm.selectedPrintDocument,
                                      type: "primary"
                                    },
                                    on: { click: _vm.originalPrint }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.getHblPrintButtonText()) +
                                        " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        pagePart.blockType ===
                        _vm.PAGE_PART_TYPE.CONTAINER_INFO.value
                          ? _c(
                              "div",
                              { staticClass: "container-info-container" },
                              [
                                _c("se-container", {
                                  ref: "seContainer",
                                  refInFor: true,
                                  attrs: {
                                    job: _vm.job,
                                    context: _vm.context,
                                    action:
                                      _vm.checkDisabled ||
                                      pagePart.containerConfig.isReadonly
                                        ? "look"
                                        : "edit",
                                    "slave-customs-declaration-enable":
                                      _vm.slaveCustomsDeclarationEnable,
                                    "master-customs-declaration-enable":
                                      _vm.masterCustomsDeclarationEnable,
                                    "container-config": pagePart.containerConfig
                                  },
                                  on: {
                                    mounted: function($event) {
                                      return _vm.handleComponentMounted(
                                        "seContainer"
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                })
              ],
              2
            )
          : _vm.isAe
          ? _c(
              "div",
              { staticClass: "preview-content" },
              _vm._l(_vm.pageParts, function(pagePart) {
                return _c(
                  "div",
                  { key: pagePart.id, staticClass: "preview-section" },
                  [
                    _c("div", { staticClass: "section-header" }, [
                      _c("span", { staticClass: "section-title" }, [
                        _vm._v(_vm._s(_vm.getLocalizedName(pagePart)))
                      ])
                    ]),
                    _c("div", { staticClass: "section-content" }, [
                      pagePart.blockType ===
                      _vm.PAGE_PART_TYPE.BUSINESS_ELEMENTS.value
                        ? _c(
                            "div",
                            { staticClass: "element-grid" },
                            [
                              _vm._l(pagePart.elements, function(element) {
                                return [
                                  _vm.isElementVisible(element) &&
                                  (_vm.eManageGet(element)
                                    ? !_vm.eManageGet(
                                        element,
                                        _vm.eManage.refreshId
                                      ).hide
                                    : true)
                                    ? _c(
                                        "div",
                                        {
                                          key: element.uuid,
                                          staticClass: "element-item",
                                          class: {
                                            "has-error":
                                              _vm.elementErrors[
                                                element.elementName
                                              ],
                                            "full-width": _vm.showFullWidth(
                                              element
                                            ),
                                            cleared:
                                              _vm.clearStates[
                                                element.elementName
                                              ]
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "element-label",
                                              class: {
                                                required:
                                                  element.isRequire ||
                                                  element.isDefaultRequire
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getLocalizedName(element)
                                                )
                                              )
                                            ]
                                          ),
                                          [
                                            _vm.eManageGet(element)
                                              ? _c(
                                                  _vm.eManageGet(element)
                                                    .component,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        key: _vm.getElementKey(
                                                          element
                                                        ),
                                                        ref:
                                                          element.elementName,
                                                        refInFor: true,
                                                        tag: "component",
                                                        class: {
                                                          "is-error":
                                                            _vm.elementErrors[
                                                              element
                                                                .elementName
                                                            ]
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            _vm.isElementDisabled(
                                                              element
                                                            ) ||
                                                            _vm.eManageGet(
                                                              element,
                                                              _vm.eManage
                                                                .refreshId
                                                            ).disabled ||
                                                            _vm.clearStates[
                                                              element
                                                                .elementName
                                                            ],
                                                          value: _vm.getFormFieldValueFormatter(
                                                            element.elementName,
                                                            element.pageType,
                                                            _vm.job
                                                          )
                                                        },
                                                        on: {
                                                          input: function(val) {
                                                            return _vm.handleElementInput(
                                                              element,
                                                              val,
                                                              _vm.eManageGet(
                                                                element,
                                                                _vm.eManage
                                                                  .refreshId
                                                              ).convertValue
                                                            )
                                                          },
                                                          change: function(
                                                            val
                                                          ) {
                                                            return _vm.handleElementChange(
                                                              element,
                                                              val,
                                                              _vm.eManageGet(
                                                                element,
                                                                _vm.eManage
                                                                  .refreshId
                                                              ).convertValue
                                                            )
                                                          },
                                                          childrenChange: function(
                                                            data
                                                          ) {
                                                            return _vm.processElementChange(
                                                              element,
                                                              "",
                                                              data
                                                            )
                                                          }
                                                        }
                                                      },
                                                      "component",
                                                      _vm.eManageGet(
                                                        element,
                                                        _vm.eManage.refreshId
                                                      ).props,
                                                      false
                                                    ),
                                                    _vm.eManageGet(
                                                      element,
                                                      _vm.eManage.refreshId
                                                    ).listeners || {}
                                                  )
                                                )
                                              : _vm.isDatePicker(element)
                                              ? _c(
                                                  "el-date-picker",
                                                  _vm._b(
                                                    {
                                                      key: element.elementName,
                                                      ref: element.elementName,
                                                      refInFor: true,
                                                      class: {
                                                        "is-error":
                                                          _vm.elementErrors[
                                                            element.elementName
                                                          ]
                                                      },
                                                      attrs: {
                                                        value: _vm.getFormFieldValue(
                                                          element.elementName,
                                                          element.pageType,
                                                          _vm.job
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "CargoMsg.Cargo_EnterValue"
                                                        ),
                                                        size: "small",
                                                        disabled:
                                                          _vm.isElementDisabled(
                                                            element
                                                          ) ||
                                                          _vm.clearStates[
                                                            element.elementName
                                                          ]
                                                      },
                                                      on: {
                                                        input: function(val) {
                                                          return _vm.handleElementInput(
                                                            element,
                                                            val
                                                          )
                                                        },
                                                        change: function(val) {
                                                          return _vm.handleElementChange(
                                                            element,
                                                            val
                                                          )
                                                        }
                                                      }
                                                    },
                                                    "el-date-picker",
                                                    _vm.getElementProps(
                                                      element,
                                                      _vm.job
                                                    ),
                                                    false
                                                  )
                                                )
                                              : _vm.isDatePickerShowWeek(
                                                  element
                                                )
                                              ? _c(
                                                  "date-picker-show-week",
                                                  _vm._b(
                                                    {
                                                      key: element.elementName,
                                                      ref: element.elementName,
                                                      refInFor: true,
                                                      class: {
                                                        "is-error":
                                                          _vm.elementErrors[
                                                            element.elementName
                                                          ]
                                                      },
                                                      attrs: {
                                                        value: _vm.getFormFieldValue(
                                                          element.elementName,
                                                          element.pageType,
                                                          _vm.job
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "CargoMsg.Cargo_EnterValue"
                                                        ),
                                                        size: "small",
                                                        disabled:
                                                          _vm.isElementDisabled(
                                                            element
                                                          ) ||
                                                          _vm.clearStates[
                                                            element.elementName
                                                          ]
                                                      },
                                                      on: {
                                                        input: function(val) {
                                                          return _vm.handleElementInput(
                                                            element,
                                                            val
                                                          )
                                                        },
                                                        change: function(val) {
                                                          return _vm.handleElementChange(
                                                            element,
                                                            val
                                                          )
                                                        }
                                                      }
                                                    },
                                                    "date-picker-show-week",
                                                    _vm.getElementProps(
                                                      element,
                                                      _vm.job
                                                    ),
                                                    false
                                                  )
                                                )
                                              : element.elementName ===
                                                "airUlds"
                                              ? [
                                                  !_vm.job.lclMasterUuid &&
                                                  _vm.job.operateType !== 0
                                                    ? _c(
                                                        "booking-air-uld-data-grid",
                                                        {
                                                          attrs: {
                                                            value:
                                                              _vm.job.airUld,
                                                            "is-edit":
                                                              !_vm.isElementDisabled(
                                                                element
                                                              ) &&
                                                              !_vm.clearStates[
                                                                element
                                                                  .elementName
                                                              ],
                                                            job: _vm.job
                                                          }
                                                        }
                                                      )
                                                    : _c("div", [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "CargoMsg.Cargo_None"
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ])
                                                ]
                                              : _c(
                                                  _vm.elementComponentMap[
                                                    element.elementName
                                                  ] || "el-input",
                                                  _vm._b(
                                                    {
                                                      key: element.elementName,
                                                      ref: element.elementName,
                                                      refInFor: true,
                                                      tag: "component",
                                                      class: {
                                                        "is-error":
                                                          _vm.elementErrors[
                                                            element.elementName
                                                          ]
                                                      },
                                                      attrs: {
                                                        value: _vm.getFormFieldValueFormatter(
                                                          element.elementName,
                                                          element.pageType,
                                                          _vm.job
                                                        ),
                                                        placeholder: _vm.$t(
                                                          "CargoMsg.Cargo_EnterValue"
                                                        ),
                                                        size: "small",
                                                        disabled:
                                                          _vm.isElementDisabled(
                                                            element
                                                          ) ||
                                                          _vm.clearStates[
                                                            element.elementName
                                                          ]
                                                      },
                                                      on: {
                                                        input: function(val) {
                                                          return _vm.handleElementInput(
                                                            element,
                                                            val
                                                          )
                                                        },
                                                        change: function(val) {
                                                          return _vm.handleElementChange(
                                                            element,
                                                            val
                                                          )
                                                        },
                                                        childrenChange: function(
                                                          data
                                                        ) {
                                                          return _vm.processElementChange(
                                                            element,
                                                            "",
                                                            data
                                                          )
                                                        }
                                                      }
                                                    },
                                                    "component",
                                                    _vm.getElementProps(
                                                      element,
                                                      _vm.job
                                                    ),
                                                    false
                                                  ),
                                                  [
                                                    _vm.isSelectType(
                                                      _vm.elementComponentMap[
                                                        element.elementName
                                                      ]
                                                    )
                                                      ? _vm._l(
                                                          _vm.getElementSelectOptions(
                                                            element
                                                          ),
                                                          function(
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: _vm.getOptionProp(
                                                                  item,
                                                                  index,
                                                                  element,
                                                                  "key"
                                                                ),
                                                                attrs: {
                                                                  label: _vm.getOptionProp(
                                                                    item,
                                                                    index,
                                                                    element,
                                                                    "label"
                                                                  ),
                                                                  value: _vm.getOptionProp(
                                                                    item,
                                                                    index,
                                                                    element,
                                                                    "value"
                                                                  )
                                                                }
                                                              }
                                                            )
                                                          }
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  2
                                                )
                                          ],
                                          _vm.elementErrors[element.elementName]
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "error-message"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.elementErrors[
                                                          element.elementName
                                                        ]
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.isBatchMode &&
                                          !_vm.isElementDisabled(element)
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "clear-checkbox-container"
                                                },
                                                [
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      staticClass:
                                                        "clear-checkbox",
                                                      attrs: {
                                                        disabled:
                                                          _vm.isElementDisabled(
                                                            element
                                                          ) ||
                                                          (_vm.eManageGet(
                                                            element,
                                                            _vm.eManage
                                                              .refreshId
                                                          ) &&
                                                            _vm.eManageGet(
                                                              element,
                                                              _vm.eManage
                                                                .refreshId
                                                            ).disabled)
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.handleClearChange(
                                                            element.elementName,
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.clearStates[
                                                            element.elementName
                                                          ],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.clearStates,
                                                            element.elementName,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "clearStates[element.elementName]"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "CargoMsg.Cargo_ClearData"
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      pagePart.blockType ===
                      _vm.PAGE_PART_TYPE.AE_CARGO_INFO.value
                        ? _c(
                            "div",
                            { staticClass: "ae-cargo-info-container" },
                            [
                              _c("ae-basic-goods-info", {
                                ref: "aeBasicGoodsInfo",
                                refInFor: true,
                                attrs: {
                                  job: _vm.job,
                                  "mawb-doc": _vm.aeMawbDoc,
                                  disabled:
                                    _vm.checkDisabled ||
                                    pagePart.aeCargoInfoConfig.isReadonly,
                                  "open-imperial": _vm.openImperial,
                                  "show-imperial-button":
                                    _vm.showImperialButton,
                                  "display-config": pagePart.aeCargoInfoConfig
                                },
                                on: {
                                  childrenChange: function(data) {
                                    return _vm.handleComponentChange(
                                      pagePart,
                                      data
                                    )
                                  },
                                  mawbDocChange: _vm.handleAeMawbComponentChange
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isCsnInfoPagePartType(pagePart.blockType)
                        ? _c("div", [
                            pagePart.blockType ===
                            _vm.PAGE_PART_TYPE.CSN_INFO_AE_BASIC.value
                              ? _c("div", { staticClass: "csn-basic-layout" }, [
                                  _vm.checkCsnFlag(pagePart, "needShipper")
                                    ? _c(
                                        "div",
                                        { staticClass: "csn-component" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "csn-component-label"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_Shipper"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c("ae-basic-shipper", {
                                            attrs: {
                                              job: _vm.job,
                                              disabled: _vm.checkCsnFlag(
                                                pagePart,
                                                "isReadonly"
                                              )
                                            },
                                            on: {
                                              childrenChange: function($event) {
                                                return _vm.handleCsnComponentChange(
                                                  pagePart,
                                                  $event
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.checkCsnFlag(pagePart, "needConsignee")
                                    ? _c(
                                        "div",
                                        { staticClass: "csn-component" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "csn-component-label"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_Consignee"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c("ae-basic-consignee", {
                                            attrs: {
                                              job: _vm.job,
                                              disabled: _vm.checkCsnFlag(
                                                pagePart,
                                                "isReadonly"
                                              )
                                            },
                                            on: {
                                              childrenChange: function($event) {
                                                return _vm.handleCsnComponentChange(
                                                  pagePart,
                                                  $event
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.checkCsnFlag(pagePart, "needNotify")
                                    ? _c(
                                        "div",
                                        { staticClass: "csn-component" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "csn-component-label"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_Notify"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c("ae-basic-notify", {
                                            attrs: {
                                              job: _vm.job,
                                              disabled: _vm.checkCsnFlag(
                                                pagePart,
                                                "isReadonly"
                                              )
                                            },
                                            on: {
                                              childrenChange: function($event) {
                                                return _vm.handleCsnComponentChange(
                                                  pagePart,
                                                  $event
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.checkCsnFlag(pagePart, "needAlsoNotify")
                                    ? _c(
                                        "div",
                                        { staticClass: "csn-component" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "csn-component-label"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "SeaExport.SecondNotifyParty"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c("cargo-rich-textarea", {
                                            staticStyle: {
                                              width: "310px",
                                              height: "230px"
                                            },
                                            attrs: {
                                              no: "alsoNotify",
                                              disabled: _vm.checkCsnFlag(
                                                pagePart,
                                                "isReadonly"
                                              ),
                                              "text-chars": 0,
                                              "wrap-symbol": "r"
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.handleAlsoNotifyChange(
                                                  pagePart,
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.job.alsoNotify,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.job,
                                                  "alsoNotify",
                                                  $$v
                                                )
                                              },
                                              expression: "job.alsoNotify"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ])
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "preview-footer" },
          [
            !_vm.checkDisabled
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handleSubmit }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Submit")))]
                )
              : _vm._e(),
            _c("el-button", { on: { click: _vm.handleCancel } }, [
              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))
            ])
          ],
          1
        )
      ]),
      _c("ai-custom-page-data-validation", {
        attrs: {
          visible: _vm.showValidationDialog,
          "validation-result": _vm.validationResult,
          "page-parts": _vm.pageParts
        },
        on: {
          "update:visible": function($event) {
            _vm.showValidationDialog = $event
          },
          close: _vm.handleValidationClose
        }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          "append-to-body": ""
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }